import React from 'react';
import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import TagMoveButtons from '../edit/TagMoveButtons';
import { TagMoveButtonsProps } from '../tagComponentPropTypes';

const TagEditMovePopup: React.FC<TagMoveButtonsProps> = (props) => {
    const { tag, showMoveMenu } = props;
    if (!tag) return null;

    return (
        <FloatingPanel
            className="light"
            selector={`#tag-move-${tag.id}`}
            pollPosition
            offset={20}
            showArrow={false}
            distance={0}
            alignment={TooltipAlignment.START}
            position={TooltipPositions.RIGHT}
            show={showMoveMenu}
        >
            <PopupPanelMouseManager visible={showMoveMenu} popupId={PopupIds.TAG_EDIT_MOVE} closePopup={() => {}}>
                <TagMoveButtons {...props} />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default TagEditMovePopup;
